var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"performance-menu"},[_c('HorizontalMenu',{attrs:{"items":_vm.items,"value":_vm.value,"size":"small","bottomLine":false},on:{"onChange":_vm.handleOnChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }